document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.collection-banner__category--inner');
  const leftArrow = document.getElementById('category-arrowLeft');
  const rightArrow = document.getElementById('category-arrowRight');

  if (!container || !leftArrow || !rightArrow) return;

  function updateArrows() {
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    // Left arrow logic
    if (scrollLeft <= 0) {
      leftArrow.style.display = 'none';
    } else {
      leftArrow.style.display = 'block';
    }

    // Right arrow logic
    if (scrollLeft >= maxScroll - 1) {
      rightArrow.style.display = 'none';
    } else {
      rightArrow.style.display = 'block';
    }
  }

  // initial state
  updateArrows();

  // on scroll
  container.addEventListener('scroll', updateArrows);

  // optional: click arrows to scroll
  leftArrow.addEventListener('click', () => {
    container.scrollBy({ left: -200, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    container.scrollBy({ left: 200, behavior: 'smooth' });
  });

  // responsive / resize fix
  window.addEventListener('resize', updateArrows);
});